import React, { useEffect } from "react"
import * as heroStyles from "./hero.module.css"
import Img from "gatsby-image/withIEPolyfill"
import DripAni from "./drip-animation.js"

const Hero = (props) => {
    
    useEffect(() => {
        DripAni();    
    }, []);
    
    return (
        <div className={`${heroStyles.hero} rel`}>
            <div className={heroStyles.background}>
                <Img 
                    fluid={props.backgroundImg.childImageSharp.fluid}
                    objectFit="cover"
                    objectPosition="50% 50%"
                    style={{height: "450px", width: "100%"}}
                    alt="" />
            </div>
            <h1 className={`${heroStyles.h1Title} drop-ani`}>{props.title}<br />{props.title2}</h1>
            <div className={heroStyles.dripTop}>
                {props.drip1}
            </div>
            {props.portraitImg &&
                <div className={heroStyles.portrait}>
                    <Img 
                        fluid={props.portraitImg.childImageSharp.fluid}
                        fadeIn={true}
                        loading="eager"
                        style={{height: "450px", width: "100vw", maxHeight: "90vh"}}
                        objectFit="contain"
                        objectPosition="93% bottom"
                        alt="" />
                </div>
            }
            <div className={heroStyles.dripBottom}> 
                {props.drip2}
            </div>
        </div>
    )
}

export default Hero
